export default function PrivacyPage() {
    return (
        <section className="pv-lg center">
            <div className="m-auto" style={{width: '90%'}}>
                <h2 className="text-2xl lg:text-4xl mb-md">Detalles de la Política de Privacidad</h2>
                <p className="text-gray-300">
                    Aquí va todo el contenido legal de privacidad, cómo se manejan los datos y la protección de usuarios.
                </p>
            </div>
        </section>
    );
}